export const GAME_CONTRACTS = {
  CAR_NFT: "xion14836hqy3km4sardm2e89s2tw6l23d9lvcfwgjwlvp44lztlxjp4q3h5uck",
  CAR_PART: "xion1jleg22pemep9gtw8s64xn7ham030xffusy484jvf27y76fll6xvqe5nfx6",
  WORKSHOP: "xion1zl0kuah4ec7vrz3n0thafkpny40sm0rp9mx8v0rengj4vmes0q3q8wf9ls",
  LEADERBOARD: "xion1zl0kuah4ec7vrz3n0thafkpny40sm0rp9mx8v0rengj4vmes0q3q8wf9ls"
}; 